import { captureException, captureMessage } from '@sentry/react'

export const logger = {
  log: (...args: unknown[]) => console.log(args),
  warn: (message: string) => {
    console.warn(message)
    captureMessage(message)
  },
  error: (error: unknown, fingerprint?: string) => {
    console.error(error)
    const hint = fingerprint ? { fingerprint: [fingerprint] } : undefined
    captureException(error, hint)
  },
}
